import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'Patente'
})
export class PatentePipe implements PipeTransform {
	transform(value: string, separador: string = "-"): string {
		let Valor: string = value;

		//Patente formato AAA000 (Autos antes de abril del 2016)
		//Patente formato 000AAA (Motos antes de abril del 2016)
		if (/^[A-Z]{3}[0-9]{3}$/.test(Valor) || /^[0-9]{3}[A-Z]{3}$/.test(Valor)) {
			Valor = [value.slice(0, 3), separador, value.slice(3)].join('');
		}

		//Patente formato AA000AA (Autos después de abril del 2016)
		if (/^[A-Z]{2}[0-9]{3}[A-Z]{2}$/.test(Valor)) {
			Valor = [value.slice(0, 2), separador, value.slice(2, 5), separador, value.slice(5)].join('');
		}

		//Patente formato A000AAA (Motos después de abril del 2016)
		if (/^[A-Z]{1}[0-9]{3}[A-Z]{3}$/.test(Valor)) {
			Valor = [value.slice(0, 1), separador, value.slice(1, 4), separador, value.slice(4)].join('');
		}

		return Valor;
	}
}